import React from "react";
import { ResourceFeature, ResourceFunction, Resources, RoleResource } from "Models/resources";
import useStyles from "./style";
import { useTranslation } from "react-i18next";
import { Roles } from "Models/user";
import { UseState } from "Types";
import { AccessRuleFeatureFunctionCardCheckbox } from "./AccessRuleFeatureFunctionCardCheckbox";

interface AccessRuleFeatureFunctionCardProps {
  accessRule?: Roles;
  feature: ResourceFeature;
  resource: Resources;
  roleResources: RoleResource[];
  functionPermissions: ResourceFunction[];
  setFunctionPermissions: UseState<ResourceFunction[]>;
  masterDataPermissions: ResourceFunction[];
  setMasterDataPermissions: UseState<ResourceFunction[]>;
}

export const AccessRuleFeatureFunctionCard = (props: AccessRuleFeatureFunctionCardProps) => {
  const {
    feature,
    accessRule,
    resource,
    roleResources,
    functionPermissions,
    setFunctionPermissions,
    masterDataPermissions,
    setMasterDataPermissions,
  } = props;
  const classes = useStyles();
  const { t: translate } = useTranslation();



  const handleChangePermissionCheckBoxForMasterData = (functionObj: ResourceFunction) => {
    if (!masterDataPermissions || masterDataPermissions?.length === 0) {
      setMasterDataPermissions([{ ...functionObj, checked: true }]);
      return;
    }

    const funcObj = masterDataPermissions?.find(
      (obj) => obj?.id === functionObj?.id && obj?.resourceId === functionObj?.resourceId
    );

    if (!funcObj) {
      setMasterDataPermissions((state) => [...state, { ...functionObj, checked: true }]);
      return;
    }

    const newFunctionObjs = masterDataPermissions?.filter(
      (obj) =>
        (obj?.id !== functionObj?.id && obj?.resourceId === functionObj?.resourceId) ||
        obj?.resourceId !== functionObj?.resourceId
    );
    setMasterDataPermissions(newFunctionObjs);
    return;
  };

  const handleSetPermissionCheckBox = (functionObj: ResourceFunction) => {
    return functionPermissions?.some((obj) => obj?.code === functionObj?.code);
  };

  const handleChangePermissionCheckBox = (functionObj: ResourceFunction, resource: Resources) => {
    if (!functionPermissions || functionPermissions?.length === 0) {
      setFunctionPermissions([{ ...functionObj, checked: true, resourceId: resource?.id }]);
      return;
    }

    const funcObj = functionPermissions?.find((obj) => obj?.code === functionObj?.code);
    if (!funcObj) {
      setFunctionPermissions((state) => [
        ...state,
        { ...functionObj, checked: true, resourceId: resource?.id },
      ]);
    } else {
      const newFunctionObjs = functionPermissions?.filter((obj) => obj?.code !== functionObj?.code);
      setFunctionPermissions(newFunctionObjs);
    }
  };

  return (
    <div className={classes.feaatureFunction}>
      <div>
        <span className={classes.subFeature}>
          {feature?.name === resource?.name || feature?.name === "Storage Boxes & Units"
            ? translate("general")
            : feature?.name}
        </span>

        <div className={classes.checkboxPermissionContainer}>
          {feature?.functions?.map((functionObj) => {
            return (
              <AccessRuleFeatureFunctionCardCheckbox 
                feature={feature}
                functionObj={functionObj}
                handleChangePermissionCheckBox={handleChangePermissionCheckBox}
                handleChangePermissionCheckBoxForMasterData={handleChangePermissionCheckBoxForMasterData}
                handleSetPermissionCheckBox={handleSetPermissionCheckBox}
                masterDataPermissions={masterDataPermissions}
                resource={resource}
                roleResources={roleResources}
                accessRule={accessRule}
                key={functionObj?.id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
